import countryCodesData from "./country-codes.json";

export const countryCodes = countryCodesData;
